import PropTypes from 'prop-types';
import Rails from '@rails/ujs';
import { updateToken } from './updateToken';
import { safelyFetchJson } from './safelyFetchJson';

export const ideaShape = PropTypes.shape({
  title: PropTypes.string,
  description: PropTypes.string,
  tasklist_external_id: PropTypes.string,
  days_to_completion: PropTypes.number
});

export const taskShape = PropTypes.shape({
  title: PropTypes.string,
  description: PropTypes.string,
  completed_at: PropTypes.string,
  summary: PropTypes.string
});

export const createAction = ({ task }) =>
  fetch(`/app/task-ui/tasklists/${task.tasklist_external_id}/tasks`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': Rails.csrfToken()
    },
    body: JSON.stringify(task)
  });

export const deleteAction = ({ task }) =>
  fetch(
    `/app/task-ui/tasklists/${task.tasklist_external_id}/tasks/${task.external_id}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-CSRF-Token': Rails.csrfToken()
      },
      body: '_method=delete'
    }
  );

export const markAsCompleteAction = ({ task }) =>
  fetch(
    `/app/task-ui/tasklists/${task.tasklist_external_id}/tasks/${task.external_id}/mark-complete`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-CSRF-Token': Rails.csrfToken()
      },
      body: '_method=put',
      redirect: 'follow'
    }
  );

export const markAsIncomplete = ({ task }) =>
  fetch(
    `/app/task-ui/tasklists/${task.tasklist_external_id}/tasks/${task.external_id}/mark-incomplete`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-CSRF-Token': Rails.csrfToken()
      },
      body: '_method=put',
      redirect: 'follow'
    }
  );

export const getUpdatedTasks = async () => {
  try {
    const { uncompleted, completed, token } = await safelyFetchJson(
      '/app/recommendations/tasks',
      {
        method: 'get'
      }
    );
    updateToken(token);
    return { uncompleted, completed };
  } catch (e) {
    throw new Error('Failed to fetch tasks');
  }
};

export const getUpdatedIdeas = async () => {
  try {
    const { ideas, token } = await safelyFetchJson(
      '/app/recommendations/ideas',
      {
        method: 'get'
      }
    );

    updateToken(token);
    return ideas;
  } catch (e) {
    throw new Error('Failed to fetch Ideas');
  }
};
